import BlueIcon_1 from "./circle_blue-1.png";
import BlueIcon_2 from "./circle_blue-2.png";
import BlueIcon_3 from "./circle_blue-3.png";
import GreenIcon_1 from "./circle_green-1.png";
import GrenIcon_2 from "./circle_green-2.png";
import GreenIcon_3 from "./circle_green-3.png";
import RedIcon_1 from "./circle_red-1.png";
import RedIcon_2 from "./circle_red-2.png";
import RedIcon_3 from "./circle_red-3.png";
import StoreUseIcon from "./icon_store-use.png";
import DeleteIcon from "./icon_delete.png";
import ReservationIcon from "./icon_reservation.png";
import ManIcon from "./icon_man.png";
import WomanIcon from "./icon_woman.png";
import NoselectionIcon from "./icon_noselection.png";
import SearchIcon from "./icon_search.png";
import ArrowIcon from "./icon_aroow-1.png";
import DualArrowIcon from "./icon_aroow-2.png";
import LockIcon from "./icon_locked.png";
import UnlockIcon from "./icon_unlocked.png";
import CheckIcon from "./icon_check.png";
import CloseIcon from "./icon_close.png";
import LogoIcon from "./icon_logo.png";
import MainColorArrowIcon from "./icon_aroow-3.png";
import NotificationIcon from "./icon_notice.png";
import GrayIcon from "./circle_gray-1.png";
import CardboardIcon from "./icon_Cardboard.png";
import HelmetIcon from "./icon_Helmet.png";
import OkumuraIcon from "./icon_Okumura.png";
import BigArrowIcon from "./icon_Arrow.png";
import PassActive from "./icon_passActive.png";
import PassInactive from "./icon_passInactive.png";
import AddIcon from "./icon_add_gray.png";
import AccordionIcon from "./accordion.png";
import QRIcon from "./icon_QR.png";
import TruckIcon from "./icon_Truck.png";
import LoupeIcon from "./icon_Loupe.png";
import GraphIcon from "./icon_Graph.png";
import SettingIcon from "./icon_Setting.png";
import PencilIcon from "./icon_Pencil.png";
import LedgerIcon from "./icon_Ledger.png";
import BlackCloseIcon from "./icon_close_black.png";

export const Icons = {
  BlueIcon_1,
  BlueIcon_2,
  BlueIcon_3,
  GreenIcon_1,
  GrenIcon_2,
  GreenIcon_3,
  RedIcon_1,
  RedIcon_2,
  RedIcon_3,
  StoreUseIcon,
  DeleteIcon,
  ReservationIcon,
  ManIcon,
  WomanIcon,
  NoselectionIcon,
  SearchIcon,
  ArrowIcon,
  DualArrowIcon,
  UnlockIcon,
  LockIcon,
  CheckIcon,
  CloseIcon,
  LogoIcon,
  MainColorArrowIcon,
  NotificationIcon,
  GrayIcon,
  HelmetIcon,
  CardboardIcon,
  OkumuraIcon,
  BigArrowIcon,
  PassActive,
  PassInactive,
  AddIcon,
  AccordionIcon,
  QRIcon,
  TruckIcon,
  LoupeIcon,
  GraphIcon,
  SettingIcon,
  PencilIcon,
  LedgerIcon,
  BlackCloseIcon
};
